import { useEffect, useState } from "react";
import { FaClock, FaUser, FaInfoCircle } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";
export default function OptionSelect({ setOptionSelected, setGeneralOptionSelected, setSelectedDoctor, setSelectedDate, setSelectedTimeSlot, selectedClinic ,doctorId,showOptions}) {
  const [selected, setSelected] = useState(doctorId ? "specific" : "general");
  const { t } = useLanguage();

  const hasDoctors = selectedClinic?.doctors?.length > 0;
  const hasGeneral = selectedClinic?.genralDays?.length > 0; // ← typo fix

  const handleSelect = (option) => {
    setSelected(option);
    setSelectedDate?.(null);
    setSelectedTimeSlot?.(null);
    if (option === "general") {
      setOptionSelected(null);
      setGeneralOptionSelected(true);
      setSelectedDoctor(null);
    } else {
      setOptionSelected(true);
      setGeneralOptionSelected(false);
      setSelectedDoctor(doctorId);
    }
  };
  useEffect(()=>{
handleSelect(selected)
  },[])

  const allOptions = [
    {
      key: "general",
      icon: <FaClock className={`text-lg ${selected === "general" ? "text-primary" : "text-placeHolder"}`} />,
      title: t("optionSelect.general.title"),
      description: t("optionSelect.general.description"),
      hint: t("optionSelect.general.hint"),
    },
    {
      key: "specific",
      icon: <FaUser className={`text-lg ${selected === "specific" ? "text-primary" : "text-placeHolder"}`} />,
      title: t("optionSelect.specific.title"),
      description: t("optionSelect.specific.description"),
      hint: t("optionSelect.specific.hint"),
    },
  ];

  // Hide specific option if no doctors
  const options = hasDoctors ? allOptions : allOptions.filter((o) => o.key !== "specific");

  const activeHint = options.find((o) => o.key === selected)?.hint;

  // If no doctors, don't render the selector at all — general is auto-selected silently
if (!hasDoctors) return null;

// If showOptions is explicitly false, hide the UI but keep the logic running
if (showOptions === false || showOptions === "false") return null;
  return (
    <div className={`flex flex-col gap-4 `}>
      <div>
        <h2 className="text-lg font-semibold text-textPrimary">{t("optionSelect.title")}</h2>
      </div>

      <div className="grid grid-cols-2 gap-3">
        {options.map((option) => {
          const isSelected = selected === option.key;
          return (
            <div
              key={option.key}
              onClick={() => handleSelect(option.key)}
              className={`relative cursor-pointer rounded-xl p-4 bg-cardColor transition-all
                ${isSelected ? "border-2 border-primary" : "border border-placeHolder"}`}
            >
              {/* {isSelected && (
                <span className="absolute top-3 right-3 text-[11px] font-medium bg-purple-100 text-primary px-2 py-0.5 rounded-full">
                  {t("optionSelect.badge")}
                </span>
              )} */}
              <div className={`w-9 h-9 rounded-full flex items-center justify-center mb-3 ${isSelected ? "bg-purple-100" : "bg-gray-100"}`}>
                {option.icon}
              </div>
              <p className="text-sm font-medium text-textPrimary">{option.title}</p>
              <p className="text-xs text-placeHolder mt-0.5">{option.description}</p>
            </div>
          );
        })}
      </div>
{selected && (
      <div className="flex items-center gap-2 bg-gray-50 rounded-lg px-3 py-2.5">
        <FaInfoCircle className="text-primary text-sm shrink-0" />
        <p className="text-xs text-placeHolder">{activeHint}</p>
      </div>)}
    </div>
  );
}